"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryAxis", {
  enumerable: true,
  get: function () {
    return _victoryAxis.default;
  }
});

var _victoryAxis = _interopRequireDefault(require("./victory-axis"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-axis/lib/index.js
// module id = 664
// module chunks = 0